import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { LogoutIco } from 'components';

import { logoutUser } from '_actions/UserAction';

import { StyledAdminHeader } from './styled';

function Header() {
  const dispatch = useDispatch();

  const logoutUserCallback = useCallback(async () => dispatch(await logoutUser()), [dispatch]);
  const handleLogout = () => {
    logoutUserCallback();
  };

  return (
    <StyledAdminHeader>
      <div onClick={() => handleLogout()}>
        <LogoutIco />
        <p>로그아웃</p>
      </div>
    </StyledAdminHeader>
  );
}

export default Header;
